/**
 * @typedef {Readonly<{ collapsible?: boolean, onListItemClick?: () => void }>
 *  & import('./PropertyProvider/PropertyContext').PropType
 *  & import('../../shared/ThemeProvider/Context').PropType} Props
 */
/** @typedef {import('config/local/NavigationItem').default} NavigationItem */
/** @typedef {Omit<import('App/shared/NavigationListComponent').Props, 'location' | 'settings'>} NavigationListProps */

import React from 'react';

import { translate } from 'App/Internationalization';
import NavigationList from 'App/shared/NavigationList';
import RoleGate from 'App/shared/RoleGate';
import navigation from 'config/local/navigation';
import { withProperty } from './PropertyProvider';
import { withTheme } from '../../shared/ThemeProvider';
import paths from '../../config/local/paths';
import { getPropertyScopedNavItems } from './Properties/propertyScopedNavigation';

/** @extends {React.Component<Props>} */
class HomeownerNavigationList extends React.Component {
	render() {
		const propertyId =
			this.props.property?.selectedProperty?.id ??
			this.props.property?.propertyList?.find(
				(property) => property.isPrimary
			)?.id ??
			this.props.property?.propertyList?.[0]?.id;
		const hasTeam = Boolean(
			this.props.theme?.agentId && this.props.theme?.teamList?.length
		);
		/** @type {NavigationItem[]} */
		const links = navigation.homeowner.linkList
			.filter((link) => link !== null)
			.flatMap((link) => {
				if (
					link.to !== paths.app.homeowner.properties.root ||
					!propertyId
				) {
					return [link];
				}

				return [
					{ ...link, exact: true },
					...getPropertyScopedNavItems(hasTeam).map((item) => ({
						icon: link.icon,
						isSubmenu: true,
						key: `homeowner-properties-${item.key}`,
						label: item.label,
						to: item.path.replace(':propertyId', propertyId),
					})),
				];
			});

		return (
			<RoleGate allowedRoles={['homeowner']}>
				<NavigationList
					collapsible={this.props.collapsible}
					heading={translate('homeowner.nav.heading')}
					links={links}
					onListItemClick={this.props.onListItemClick}
				/>
			</RoleGate>
		);
	}
}

export default withTheme(withProperty(HomeownerNavigationList));
